import { ItemLevels } from "lib/hooks/usePackAssets";
import { useDragLayer } from "react-dnd";
import { DefaultDragPreview, GroupDragPreview, AssetDragPreview, MultiDragPreview } from "./drag-layer";

function getItemStyles(
  offset: { x: number, y: number } | null ,
) {
  if (!offset) {
    return {
      display: 'none',
    }
  }

  let { x, y } = offset

  const transform = `translate(${x}px, ${y}px)`
  return {
    zIndex: "1001",
    position: 'fixed',
    top: "0",
    left: "0",
    pointerEvents: 'none',
    transform,
    WebkitTransform: transform,
    cursor: 'move',
  }
}

export const CustomDragLayer = () => {
  const { isDragging, item, offset } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    isDragging: monitor.isDragging(),
    offset: monitor.getClientOffset(),
  }))

  if (!isDragging || !item?.level) {
    return null
  }

  const styles = getItemStyles(offset);
  const hasDraggedMultipleItems = item?.selectedAssets?.length;

  if (hasDraggedMultipleItems) {
    return <MultiDragPreview styles={styles} count={item.selectedAssets.length} />
  }

  switch (item.level) {
    case ItemLevels.GROUP:
      return <GroupDragPreview styles={styles} item={item} />
    case ItemLevels.ASSET:
      return <AssetDragPreview styles={styles} />
    default:
      return <DefaultDragPreview styles={styles} />
  }
};
